export const submitValidation = (question: any) => {
  let errorHandler = {
    basic: "",
    choices: "",
    repeatedConfig: "",
    gridConfig: "",
    validations: "",
    summary: "",
    ok: true,
  };

  const basicError = () => {
    errorHandler.ok = false;
    errorHandler.basic = "Fill all the required fields";
  };

  // Common Validation
  if (!question?.label?.trim()) {
    basicError();
  }

  // Question Specific Validation
  const { properties } = question;

  if (question?.type === "slider") {
    if (!properties?.minLabel) {
      basicError();
    } else if (!properties?.maxLabel) {
      basicError();
    }
  }

  // Choices Validation
  const { choices } = question;

  if (choices) {
    let label = false;

    for (let i = 0; i < choices?.length; i++) {
      const choice = question?.choices[i];
      if (!choice?.label) {
        label = true;
      }
    }

    if (label) {
      errorHandler = {
        ...errorHandler,
        ok: false,
        choices: `Choices need labels`,
      };
    }
  }

  const { summaryMap } = question;

  if (summaryMap) {
    let summary = false;

    for (let i = 0; i < summaryMap?.length; i++) {
      const item = question?.summaryMap[i];
      if (!item?.key || !item?.value) {
        summary = true;
      }
    }

    if (summary) {
      errorHandler = {
        ...errorHandler,
        ok: false,
        summary: "Enter all keys and values",
      };
    }
  }

  return { errorHandler };
};
